// prefer default export if available
const preferDefault = m => m && m.default || m

exports.components = {
  "component---src-pages-404-js": () => import("./../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-stories-index-js": () => import("./../src/pages/stories_index.js" /* webpackChunkName: "component---src-pages-stories-index-js" */),
  "component---src-templates-generic-content-template-js": () => import("./../src/templates/genericContentTemplate.js" /* webpackChunkName: "component---src-templates-generic-content-template-js" */),
  "component---src-templates-index-template-js": () => import("./../src/templates/indexTemplate.js" /* webpackChunkName: "component---src-templates-index-template-js" */),
  "component---src-templates-stories-template-js": () => import("./../src/templates/storiesTemplate.js" /* webpackChunkName: "component---src-templates-stories-template-js" */)
}

